export const siteConfig = {
  brand: {
    companyName: "NgSys Automatisation",
    companyLegal: "NgSys Automatisation",
    tagline: {
      fr: "Conception et intégration de panneaux électriques industriels",
      en: "Industrial Control Panel Design & Integration"
    },
    serviceArea: {
      fr: "Partout au Canada",
      en: "Across Canada"
    },
    primaryCTA: {
      fr: "Demander une soumission",
      en: "Request a Quote"
    },
    secondaryCTA: {
      fr: "Parler à notre agent IA",
      en: "Chat with our AI Assistant"
    }
  },
  theme: {
    primary: "#2D8ED6",
    primaryDark: "#1F5F99",
    accent: "#F28C28",
    accentHover: "#D87417",
    light: {
      bg: "#FFFFFF",
      bgAlt: "#F4F6F8",
      text: "#2E2E2E",
      textMuted: "#6E7A86"
    },
    dark: {
      bg: "#0F2A3F",
      bgAlt: "#132F46",
      surface: "#1A3A55",
      text: "#FFFFFF",
      textMuted: "#B0C4D4"
    },
    radius: 8
  },
  typography: {
    headingFont: "Montserrat",
    bodyFont: "Inter"
  },
  nav: {
    fr: ["Accueil", "Services", "Réalisations", "Secteurs", "À propos", "Contact"],
    en: ["Home", "Services", "Projects", "Industries", "About", "Contact"]
  },
  routes: {
    fr: ["/", "/services", "/projets", "/secteurs", "/a-propos", "/contact"],
    en: ["/", "/services", "/projects", "/industries", "/about", "/contact"]
  },
  home: {
    hero: {
      title: {
        fr: "NgSys Automatisation — Conception et intégration de panneaux électriques industriels",
        en: "NgSys Automation — Industrial Control Panel Design & Integration"
      },
      subtitle: {
        fr: "De la conception sous AutoCAD Electrical à la mise en service sur site, nous accompagnons les manufacturiers partout au Canada.",
        en: "From AutoCAD Electrical design to on-site commissioning, we support manufacturers across Canada."
      }
    },
    premiumLine: {
      fr: "Nous ne programmons pas seulement des machines. Nous structurons leurs données pour l'intelligence industrielle de demain.",
      en: "We don’t just program machines. We structure their data for tomorrow’s industrial intelligence."
    }
  },
  services: [
    {
      key: "design",
      title: {
        fr: "Conception de panneaux électriques (AutoCAD Electrical)",
        en: "Electrical Panel Design (AutoCAD Electrical)"
      },
      bulletsFR: [
        "Schémas unifilaires et multifilaires",
        "Plans de contrôle et puissance",
        "Nomenclature (BOM)",
        "Repérage borniers et I/O",
        "Dossiers techniques complets"
      ],
      bulletsEN: [
        "Single-line & multi-line schematics",
        "Control & power diagrams",
        "Bill of Materials (BOM)",
        "Terminal & I/O labeling",
        "Complete technical documentation"
      ],
      icon: "FileText"
    },
    {
      key: "manufacturing",
      title: {
        fr: "Fabrication de panneaux électriques",
        en: "Electrical Panel Manufacturing"
      },
      bulletsFR: [
        "Assemblage en atelier",
        "Câblage industriel professionnel",
        "Tests électriques et validation",
        "Documentation FAT",
        "Traçabilité documentaire"
      ],
      bulletsEN: [
        "Professional industrial assembly",
        "Precision wiring",
        "Electrical testing & validation",
        "FAT documentation",
        "Documentation traceability"
      ],
      icon: "Box"
    },
    {
      key: "automation",
      title: {
        fr: "Automatisation et intégration",
        en: "Automation & Integration"
      },
      bulletsFR: [
        "Programmation PLC / HMI",
        "Intégration variateurs et servomoteurs",
        "Communication industrielle (EtherNet/IP, Profinet, Modbus)",
        "Mise en service et optimisation",
        "Support technique structuré"
      ],
      bulletsEN: [
        "PLC / HMI programming",
        "VFD & servo integration",
        "Industrial networking",
        "Commissioning & optimization",
        "Structured technical support"
      ],
      icon: "Cpu"
    }
  ],
  process: {
    steps: [
      {fr: "Découverte", en: "Discovery"},
      {fr: "Conception", en: "Design"},
      {fr: "Fabrication", en: "Build"},
      {fr: "Tests FAT", en: "FAT"},
      {fr: "Mise en service", en: "Commissioning"},
      {fr: "Support", en: "Support"}
    ]
  },
  industries: {
    fr: ["Manufacturier", "Agroalimentaire", "Emballage", "Transformation plastique", "Machines spéciales", "Bâtiments industriels"],
    en: ["Manufacturing", "Food & Beverage", "Packaging", "Plastics Processing", "Special Machines", "Industrial Buildings"]
  },
  differentiators: {
    fr: [
      "600V industriel canadien",
      "Conformité CSA (selon exigences applicables)",
      "Programmation propre et documentée",
      "Service partout au Canada",
      "Support technique rapide"
    ],
    en: [
      "Canadian 600V industrial systems",
      "CSA-aligned compliance (as applicable)",
      "Clean, documented programming",
      "Service across Canada",
      "Fast technical support"
    ]
  },
  industry4: {
    title: {
      fr: "Architecture de données Industry 4.0",
      en: "Industry 4.0 Data Architecture"
    },
    bullets: {
      fr: [
        "Collecte de données PLC en temps réel",
        "Historisation sécurisée",
        "Analyse des séquences",
        "Agents IA futurs",
        "Accès web sécurisé"
      ],
      en: [
        "Real-time PLC data collection",
        "Secure historization",
        "Sequence analysis",
        "Future AI agents",
        "Secure web access"
      ]
    }
  },
  industry5: {
    title: {
      fr: "Industry 5.0 — Automatisation centrée humain",
      en: "Industry 5.0 — Human-Centric Automation"
    },
    bullets: {
      fr: [
        "Assistance IA aux opérateurs",
        "Décision basée données",
        "Réduction du stress maintenance",
        "Résilience industrielle"
      ],
      en: [
        "AI-assisted operators",
        "Data-driven decisions",
        "Reduced troubleshooting time",
        "Improved industrial resilience"
      ]
    }
  },
  vision: {
    fr: "Notre mission est de concevoir des systèmes électriques et d’automatisation structurés pour la performance immédiate et l’intelligence future.",
    en: "Our mission is to design electrical and automation systems structured for immediate performance and future intelligence."
  },
  values: {
    fr: [
      {title: "Fiabilité", desc: "Systèmes robustes conçus pour durer"},
      {title: "Documentation", desc: "Chaque projet est complètement documenté"},
      {title: "Sécurité", desc: "Conformité aux normes canadiennes"},
      {title: "Maintenabilité", desc: "Code clair pour support long terme"}
    ],
    en: [
      {title: "Reliability", desc: "Robust systems built to last"},
      {title: "Documentation", desc: "Every project is fully documented"},
      {title: "Safety", desc: "Canadian standards compliance"},
      {title: "Maintainability", desc: "Clean code for long-term support"}
    ]
  },
  projects: [
    {
      title: {fr: "Ligne d'emballage automatique", en: "Automated Packaging Line"},
      industry: {fr: "Emballage", en: "Packaging"},
      technologies: "Allen-Bradley PLC, Cognex Vision",
      outcome: {fr: "Réduction de 40% du temps de cycle", en: "40% cycle time reduction"},
      location: "Montréal, QC",
      image: "/images/20241017_101954.jpg"
    },
    {
      title: {fr: "Système de contrôle CVC industriel", en: "Industrial HVAC Control System"},
      industry: {fr: "Bâtiments industriels", en: "Industrial Buildings"},
      technologies: "Siemens S7-1500, Profinet",
      outcome: {fr: "Économie d'énergie de 30%", en: "30% energy savings"},
      location: "Toronto, ON",
      image: "/images/20240621_103052.jpg"
    },
    {
      title: {fr: "Automatisation d'extrudeuse plastique", en: "Plastic Extruder Automation"},
      industry: {fr: "Transformation plastique", en: "Plastics Processing"},
      technologies: "Rockwell CompactLogix, EtherNet/IP",
      outcome: {fr: "Précision +25% sur épaisseur", en: "+25% thickness precision"},
      location: "Québec, QC",
      image: "/images/20240703_184903.jpg"
    },
    {
      title: {fr: "Ligne de production agroalimentaire", en: "Food Production Line"},
      industry: {fr: "Agroalimentaire", en: "Food & Beverage"},
      technologies: "Schneider M580, Modbus TCP",
      outcome: {fr: "Traçabilité complète des lots", en: "Complete batch traceability"},
      location: "Calgary, AB",
      image: "/images/20241030_110201.jpg"
    },
    {
      title: {fr: "Robot de soudage automatisé", en: "Automated Welding Robot"},
      industry: {fr: "Machines spéciales", en: "Special Machines"},
      technologies: "Fanuc Robot, ABB PLC",
      outcome: {fr: "Qualité de soudure +35%", en: "+35% weld quality"},
      location: "Vancouver, BC",
      image: "/images/20250123_151423.jpg"
    },
    {
      title: {fr: "Système de convoyage intelligent", en: "Smart Conveyor System"},
      industry: {fr: "Manufacturier", en: "Manufacturing"},
      technologies: "Omron NJ-Series, EtherCAT",
      outcome: {fr: "Débit +50%, maintenance -20%", en: "+50% throughput, -20% maintenance"},
      location: "Halifax, NS",
      image: "/images/20241107_142932.jpg"
    }
  ],
  contact: {
    email: "info@ngsys.ca",
    phone: "+1 (514) 555-0100",
    address: {
      fr: "Montréal, Québec",
      en: "Montreal, Quebec"
    }
  },
  provinces: [
    "Alberta", "British Columbia", "Manitoba", "New Brunswick",
    "Newfoundland and Labrador", "Nova Scotia", "Ontario",
    "Prince Edward Island", "Quebec", "Saskatchewan"
  ],
  voltages: ["120V", "240V", "480V", "600V"],
  plcBrands: [
    "Allen-Bradley / Rockwell",
    "Siemens",
    "Schneider Electric",
    "Omron",
    "Mitsubishi",
    "ABB",
    "GE / Emerson",
    "Autre / Other"
  ],
  timelines: [
    {fr: "Urgent (< 1 mois)", en: "Urgent (< 1 month)"},
    {fr: "Court terme (1-3 mois)", en: "Short term (1-3 months)"},
    {fr: "Moyen terme (3-6 mois)", en: "Medium term (3-6 months)"},
    {fr: "Long terme (6+ mois)", en: "Long term (6+ months)"}
  ],
  seo: {
    home: {
      title: {
        fr: "NgSys Automatisation | Conception de Panneaux Électriques Industriels",
        en: "NgSys Automation | Industrial Control Panel Design"
      },
      description: {
        fr: "Conception, fabrication et intégration de panneaux électriques industriels partout au Canada. AutoCAD Electrical, PLC, HMI.",
        en: "Design, manufacturing and integration of industrial control panels across Canada. AutoCAD Electrical, PLC, HMI."
      }
    },
    services: {
      title: {
        fr: "Services | Conception, Fabrication, Automatisation",
        en: "Services | Design, Manufacturing, Automation"
      },
      description: {
        fr: "Découvrez nos services: conception AutoCAD Electrical, fabrication de panneaux jusqu'à 600V, programmation PLC et intégration.",
        en: "Discover our services: AutoCAD Electrical design, panel manufacturing up to 600V, PLC programming and integration."
      }
    },
    projects: {
      title: {
        fr: "Réalisations | Projets d'Automatisation Industrielle",
        en: "Projects | Industrial Automation Projects"
      },
      description: {
        fr: "Exemples de projets réussis en automatisation: emballage, agroalimentaire, plastique, et plus.",
        en: "Successful automation project examples: packaging, food & beverage, plastics, and more."
      }
    }
  }
};